import React from "react";
import { Box, MainTitle, RedirectSelection } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import { SeparatorLine } from "app/components/common/SeparatorLine";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import { useNavigation } from "@react-navigation/native";

interface IProps {}

const ProfileOthers = ({}: IProps) => {
  const navigation = useNavigation();

  const seeLegals = () => {
    navigation.navigate("Legal");
  };

  const changeNotification = () => {
    navigation.navigate("SetReminders");
  };

  const navigateGoalScreen = () => {
    navigation.navigate("WeeklyGoal", { isComingFromSignup: false });
  };

  return (
    <AnimatedBox style={styles.mainBox}>
      <Box paddingHorizontal="xm">
        <MainTitle variant="l7-bold" marginBottom="s">
          {i18n.t("others")}
        </MainTitle>
        <RedirectSelection
          testID="my-goals"
          text={i18n.t("my-goals")}
          onPress={navigateGoalScreen}
        />
      </Box>
      <SeparatorLine />
      {!isWeb && (
        <>
          <Box paddingHorizontal="xm">
            <RedirectSelection
              testID="notifications"
              text={i18n.t("notifications")}
              onPress={changeNotification}
            />
          </Box>
          <SeparatorLine />
        </>
      )}
      <Box paddingHorizontal="xm">
        <RedirectSelection
          testID="legal"
          text={i18n.t("legal")}
          onPress={seeLegals}
        />
      </Box>
    </AnimatedBox>
  );
};

const styles = {
  mainBox: {
    alignSelf: "center",
    width: "100%",
    marginBottom: 15,
    paddingHorizontal: 0,
  },
};

export default ProfileOthers;
